declare var dataLayer: any;

export default class TradeRegistration {
	constructor() {
		const form = document.querySelector<HTMLFormElement>(".js-trade-registration-form");
		if (!form) {
			return;
		}

		const typeOfBusiness = form.querySelector<HTMLSelectElement>(".js-trade-registration-type-of-business");
		const whereDidYouHearAboutUs = form.querySelector<HTMLSelectElement>(".js-trade-registration-where-did-you-hear-about-us");

		if (typeOfBusiness) {
			dataLayer.push({ type_of_business: typeOfBusiness.value });

			typeOfBusiness.addEventListener("change", () => {
				dataLayer.push({ type_of_business: typeOfBusiness.value });
			});
		}

		if (whereDidYouHearAboutUs) {
			dataLayer.push({ where_did_you_hear_about_us: whereDidYouHearAboutUs.value });

			whereDidYouHearAboutUs.addEventListener("change", () => {
				dataLayer.push({ where_did_you_hear_about_us: whereDidYouHearAboutUs.value });
			});
		}
	}
}
